// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageSelect__select-d237c0 {
  margin-inline-start: auto;
}

.MessageSelect__is-channel-a86e9a {
  margin-inline-start: 0;
}

.MessageSelect__checkbox-ae1ba0 {
  flex: 1;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;
  justify-content: flex-end;
  cursor: pointer;
}

.MessageSelect__input-fa8a42 {
  visibility: hidden;
  position: absolute;
}

.MessageSelect__active-container-ffb426 {
  position: relative;
}

.MessageSelect__active-a4b952 {
  fill: var(--brand-primary-40);
  display: block;
}

.MessageSelect__active-a4b952 > path:last-child {
  fill: var(--addition-50);
}

.MessageSelect__active-border-c3b14d {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid var(--addition-50);
  position: absolute;
  top: 0;
  left: 0;
}

.MessageSelect__inactive-b35722 {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid var(--addition-50);
  background-color: var(--addition-40_10);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/components/MessageSelect/MessageSelect.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,6BAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uCAAA;AACF","sourcesContent":[".select {\n  margin-inline-start: auto;\n}\n\n.is-channel {\n  margin-inline-start: 0;\n}\n\n.checkbox {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 100%;\n  justify-content: flex-end;\n  cursor: pointer;\n}\n\n.input {\n  visibility: hidden;\n  position: absolute;\n}\n\n.active-container {\n  position: relative;\n}\n\n.active {\n  fill: var(--brand-primary-40);\n  display: block;\n}\n\n.active > path:last-child {\n  fill: var(--addition-50);\n}\n\n.active-border {\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid var(--addition-50);\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.inactive {\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid var(--addition-50);\n  background-color: var(--addition-40_10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `MessageSelect__select-d237c0`,
	"is-channel": `MessageSelect__is-channel-a86e9a`,
	"isChannel": `MessageSelect__is-channel-a86e9a`,
	"checkbox": `MessageSelect__checkbox-ae1ba0`,
	"input": `MessageSelect__input-fa8a42`,
	"active-container": `MessageSelect__active-container-ffb426`,
	"activeContainer": `MessageSelect__active-container-ffb426`,
	"active": `MessageSelect__active-a4b952`,
	"active-border": `MessageSelect__active-border-c3b14d`,
	"activeBorder": `MessageSelect__active-border-c3b14d`,
	"inactive": `MessageSelect__inactive-b35722`
};
module.exports = ___CSS_LOADER_EXPORT___;
